<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <!--Forms-->
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              multiple
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationType">Location Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationType"
                                              name="locationType"
                                              id="locationType"
                                              label="text"
                                              :clearable="false"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="locationTypeArr"
                                              placeholder="Select Location Type">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="url">URL :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="url" type="text" maxlength="50" class="form-control" id="url" placeholder="URL">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{urlError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="phone">Phone :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea v-model="phone" class="form-control" id="phone" placeholder="Phone No."></textarea>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{phoneError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="group">Group :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="group" class="form-control" id="group" placeholder="Group" maxlength="190"/>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="typeId">Type Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="typeId"
                                              @change="changedValue"
                                              name="typeId"
                                              id="typeId"
                                              label="text"
                                              @input="changedValueType()"
                                              :filterable="false"
                                              :options="typeArr"
                                              @search="onSearchType"
                                              placeholder="Select Type">
                                        <template slot="no-options">
                                            Search Provider...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{typeNameError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="typeId">Provider Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="providerIdSearch"
                                              name="providerData"
                                              id="providerData"
                                              @input="changedValueProvider()"
                                              label="text"
                                              :filterable="false"
                                              :options="providerArr"
                                              placeholder="Select Provider">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{providerNameError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="typeId">Status :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="status"
                                            name="status"
                                            id="status"
                                            @input="changedStatus()"
                                            label="text"
                                            :options="statusArr"
                                            :filterable="false"
                                            :clearable="false"
                                            :searchable="false"
                                            placeholder="Select Status">
                                    </v-select>
                                    <!-- <div class="requiredstar">*</div> -->
                                    <!-- <font class="text-danger">{{providerNameError}}</font> -->
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addBenefit()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addBenefit(flag='Save and Continue')">
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    export default {
        name: 'AddBenefits',
        components: {
            'app-backend-footer': BackendFooter,
            'v-select': vSelect,
        },
        mixins: [SessioMixin],
        data() {
            return {
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                selectedProvider: 0,
                pageTitle: '',
                url: '',
                group: '',
                phone: '',
                locationId: '',
                locationArr: [],
                providerData: '',
                providerArr: [],
                providerIdSearch: '',
//                providerId : '',
//                providerArr : [],
                typeId: '',
                typeArr: [],
                status: {text: 'Active', value: 1},
                statusArr : [{ text: "Active", value: 1}, { text: "Inactive", value: 0}],

                locationError: '',
                urlError: '',
                phoneError: '',
                typeNameError: '',
                providerNameError: '',
            }
        },

        watch: {
            typeId: function (typeId) {
                var typeid = (typeId === null || typeId == '') ? 0 : self.typeId.value;
                if (typeid) {
                    self.getProvider(typeid);
                }
//                var data = {
//                    type_id : self.typeId.value,
//                };
//                console.log(self.typeId.value);
//                HTTP.post("searchprovider", data)
//                    .then(function (response) {
//                        self.providerArr = response.data.content;
////                        $('#providerData').on('change', function () {
//                            self.providerId = self.providerIdSearch;
//                            console.log(self.providerIdSearch);
////                        });
//                    })
//                    .catch(function (err) {
//                        if (err.response.status == 0) {
//                            self.error = "Remote server can not be reachable";
//                        } else {
//                            //redirect to login page if user not authenticated
//                            if (err.response.status == 401) {
//                                //clear previous data
//                                localStorage.removeItem("user_obj");
//                                localStorage.removeItem("api_token");
//                                localStorage.removeItem("profile_image");
//                                //EventBus.$emit("logged-in", true, "", "");
//                                self.$router.push("/login");
//                            }
//                            self.error = err.response.data.message;
//                        }
//                    });
            }
        },

        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            var path = window.location.pathname;
            var segments = path.split("/");
            self.loadLocationsAdd();
//            self.loadProviderAdd();
            self.loadTypeAdd();
            self.pageTitle = 'Add Benefit';
            if (segments[2] == 'updatebenefits') {
                if (segments[3]) {
                    self.pageTitle = 'Edit Benefit';
                    self.loadBenefit();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit");
                }
            }
            $("#alertError").hide();
            $("#locationId").on('change', function () {
                self.locationError = '';
            });
            $("#url").on('keyup', function () {
                self.urlError = '';
            });
            $("#phone").on('keyup', function () {
                self.phoneError = '';
            });
            $("#providerData").change(function () {
                self.providerNameError = '';
            });
            $("v-select").change(function () {
                self.locationError = "";
                self.typeNameError = "";
            });
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listbenefits');
            },

            changedValue: function (value) {

            },

            changedValueLocation: function () {
                self.locationError = "";
            },

            changedValueType: function () {
                self.typeNameError = "";
            },
            changedValueProvider: function () {
                self.providerNameError = "";
            },
            changedStatus: function () {
                //
            },

            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
//            onSearchProvider(search, loading) {
//                if (search.length > 2) {
//                    if (typeof (loading) != "undefined") {loading(true);}
//                    this.loadProviderAdd(loading, search, this);
//                }
//            },
            onSearchType(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadTypeAdd(loading, search, this);
                }
            },

            checkForm: function () {
                var checked = true;
//                self.locationId = "";
//                self.url = "";
//                self.phone = "";
//                self.typeId = "";

                if (self.locationId.length === 0) {
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.url) {
                    self.urlError = "URL Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.phone) {
                    self.phoneError = "Phone Number Required";
                    if (checked) {
                        checked = false;
                    }
                }/* else if (self.phone && !String(self.phone).match(/^[0-9]*$/)) {
                 self.phoneError = "Phone Number Must Be Numeric";
                 if (checked) {
                 checked = false;
                 }
                 } else if (self.phone && String(self.phone).match(/^[0-9]*$/) && self.phone.length < 10) {
                 self.phoneError = "Phone Number Must Be Of Minimum 10 Digits";
                 if (checked) {
                 checked = false;
                 }
                 } else if (self.phone && String(self.phone).match(/^[0-9]*$/) && self.phone.length > 13) {
                 self.phoneError = "Phone Number Must Be Of Maximum 13 Digits";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                if (!self.typeId) {
                    self.typeNameError = "Type Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.providerIdSearch) {
                    self.providerNameError = "Provider Name Required"
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            /*$.each(response.data.content, function (i) {
                             if (response.data.content[i].value == 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });
                             $.each(response.data.content, function (i) {
                             if (response.data.content[i].value != 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });*/
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            loadTypeAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("searchtype", data)
                        .then(function (response) {
                            self.typeArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            addBenefit(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };

                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");

                    if (segments[2] == 'updatebenefits') {
                        if (segments[3]) {
                            var data = {
                                location_id: locationsId,
                                location_type: self.locationType.value,
                                url: self.url,
                                group: self.group,
                                phone: self.phone,
                                type_id: self.typeId.value,
                                provider_id: self.providerIdSearch.value,
                                status: self.status.value,
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            location_id: locationsId,
                            location_type: self.locationType.value,
                            url: self.url,
                            group: self.group,
                            phone: self.phone,
                            type_id: self.typeId.value,
                            provider_id: self.providerIdSearch.value,
                            status: self.status.value
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdatebenefit", data, config)
                            .then(function (response) {

//                        console.log(response.data.content);
                                if (segments[2] == 'updatebenefits') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");

                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.locationType = '';
                                        self.phone = '';
                                        self.url = '';
                                        self.group = '';
                                        self.typeId = '';
                                        self.locationArr = [];
                                        self.typeArr = [];
                                        self.providerArr = [];
                                        self.providerIdSearch = '';
                                        self.status = { text : "Active", value : 1};
                                        self.loadLocationsAdd();
                                        self.loadTypeAdd();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatebenefits') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.locationId = '';
                                            self.locationType = '';
                                            self.phone = '';
                                            self.url = '';
                                            self.group = '';
                                            self.typeId = '';
                                            self.locationArr = [];
                                            self.typeArr = [];
                                            self.providerArr = [];
                                            self.providerIdSearch = '';
                                            self.status = { text : "Active", value : 1};
                                            self.loadLocationsAdd();
                                            self.loadTypeAdd();
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.locationId = '';
                                        self.locationType = '';
                                        self.phone = '';
                                        self.url = '';
                                        self.group = '';
                                        self.typeId = '';
                                        self.locationArr = [];
                                        self.typeArr = [];
                                        self.providerArr = [];
                                        self.providerIdSearch = '';
                                        self.status = { text : "Active", value : 1};
                                        self.loadLocationsAdd();
                                        self.loadTypeAdd();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show")
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }
            },

            loadBenefit: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getbenefits/" + segments[3], data, config)
                        .then(function (response) {
//                        self.locationId = response.data.content[0].location_name;
//                             self.locationId = {
//                                 value: response.data.content[0].location_id,
//                                 text: response.data.content[0].location_name,
//                             };
                            self.locationId = [];
                            for (var i = 0; i < response.data.content[0].location.length; i++) {
                                self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                            }
                            self.locationType = {'text': self.formatString(response.data.content[0].location_type), 'value': response.data.content[0].location_type};
                            self.phone = response.data.content[0].phone;
                            self.url = response.data.content[0].url;
                            self.group = response.data.content[0].group;
//                        self.typeId = response.data.content[0].benifit_type;
                            self.typeId = {
                                value: response.data.content[0].type_id,
                                text: response.data.content[0].type_name,
                            };
                            self.selectedProvider = response.data.content[0].provider_id;
                            self.getProvider(response.data.content[0].type_id);
                            self.providerIdSearch = {
                                value: response.data.content[0].provider_id,
                                text: response.data.content[0].provider_name
                            };
                            self.status = { text: response.data.content[0].statusVal, value: response.data.content[0].status};
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            getProvider: function (typeId) {
                var data = {
                    type_id: typeId,
                };
                HTTP.post("searchprovider", data)
                        .then(function (response) {
                            self.providerArr = [];
                            /*self.providerArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (self.selectedProvider > 0 && response.data.content[i].value == self.selectedProvider) {
                                    self.providerIdSearch = {
                                        value: response.data.content[i].value,
                                        text: response.data.content[i].text
                                    };
                                } else {
                                    self.providerIdSearch = {
                                        value: response.data.content[0].value,
                                        text: response.data.content[0].text
                                    };
                                }
                                self.providerArr.push(response.data.content[i]);
                            });
                            /*self.providerIdSearch = {
                             value: response.data.content[0].value,
                             text: response.data.content[0].text
                             };*/
                            /*$('#providerData').on('change', function () {
                             self.providerId = self.providerIdSearch.value;
                             });*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                value = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return value;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/benefits/AddBenefits.vue